<template>
  <div>
    <VCard title="Ticket Management Board 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'ticket-management-board',
  },  
})
</script>
